export const DEFAULT_BOUNDING_BOX = {
  nw: {
    lat: 40.71596621809843,
    lng: -74.02282298156737,
  },
  se: {
    lat: 40.69937497516602,
    lng: -73.99999201843261,
  },
  sw: {
    lat: 40.69937497516602,
    lng: -74.02282298156737,
  },
  ne: {
    lat: 40.71596621809843,
    lng: -73.99999201843261,
  },
};

export const DEFAULT_MAP_COORDINATES = {
  lat: 40.7045389,
  lng: -74.0133233,
};
